export default __webpack_public_path__ + "static/media/csd.4c4b5d87.csv";